<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.2002 13.5999V2.3999H8.8002L9.2002 3.9999H12.8002V10.3999H8.8002L8.4002 8.7999H4.4002V13.5999H3.2002ZM9.73353 9.1999H11.6002V5.1999H8.26686L7.86686 3.5999H4.4002V7.5999H9.33353L9.73353 9.1999Z"
      fill="#383838"
    />
  </svg>
</template>
